import React, { useState } from 'react';
import { Collapse, CardBody, Card } from 'reactstrap';
import { Link } from 'react-router-dom';
import './style.css';
import { useTranslation } from 'react-i18next';

const menus = [
    { id: 1, title: 'Home', titleAr: 'الرئيسية', link: '/home' },
    { id: 2, title: 'About', titleAr: 'من نحن', link: '/about' },
    { id: 3, title: 'Services', titleAr: 'خدماتنا', link: '/service' },
    { id: 4, title: 'Projects', titleAr: 'أعمالنا', link: '/project' },
    { id: 5, title: 'Blog', titleAr: 'مدونة', link: '/blog' },
    { id: 88, title: 'Contact', titleAr: 'اتصل بنا', link: '/contact' },
];

const MobileMenu = () => {
    const [isMenuShow, setMenuShow] = useState(false);
    const [isOpen, setIsOpen] = useState(0);
    const { t, i18n } = useTranslation();
    const menuHandler = () => {
        setMenuShow(!isMenuShow);
    };

    const toggleSubmenu = (id) => {
        setIsOpen(id === isOpen ? 0 : id);
    };

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    return (
        <div>
            <div className={`mobileMenu ${isMenuShow ? 'show' : ''}`}>
                <div className="menu-close">
                    <div className="clox" onClick={menuHandler}>
                        <i className="ti-close"></i>
                    </div>
                </div>

                <ul className="responsivemenu">
                    {menus.map((item) => (
                        <li key={item.id}>
                            {item.submenu ? (
                                <p onClick={() => toggleSubmenu(item.id)}>
                                    {i18n.language === "ar" ? item.titleAr : item.title}
                                    <i className="fa fa-angle-right" aria-hidden="true"></i>
                                </p>
                            ) : (
                                <Link onClick={ClickHandler} to={item.link}>
                                    {i18n.language === "ar" ? item.titleAr : item.title}
                                </Link>
                            )}
                            {item.submenu && (
                                <Collapse isOpen={item.id === isOpen}>
                                    <Card>
                                        <CardBody>
                                            <ul>
                                                {item.submenu.map((submenu) => (
                                                    <li key={submenu.id}>
                                                        <Link onClick={ClickHandler} className="active" to={submenu.link}>
                                                            {submenu.title}
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </CardBody>
                                    </Card>
                                </Collapse>
                            )}
                        </li>
                    ))}
                    <li>
                        <a href="https://Portal.alriyada.om" className="login" target="_blank" rel="noopener noreferrer">
                            <i className="ti-user" /> {t("login")}
                        </a>
                    </li>
                </ul>

            </div>

            <div className="showmenu" onClick={menuHandler}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    );
};

export default MobileMenu;
